/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobCategoryExcludingFcmMessageIdFcmTokenWithRelations } from './jobCategoryExcludingFcmMessageIdFcmTokenWithRelations';
import { JobPositionExcludingFcmMessageIdFcmTokenWithRelations } from './jobPositionExcludingFcmMessageIdFcmTokenWithRelations';
import { InactiveReasonExcludingFcmMessageIdFcmTokenWithRelations } from './inactiveReasonExcludingFcmMessageIdFcmTokenWithRelations';
import { CityExcludingFcmMessageIdFcmTokenWithRelations } from './cityExcludingFcmMessageIdFcmTokenWithRelations';
import { AreaExcludingFcmMessageIdFcmTokenWithRelations } from './areaExcludingFcmMessageIdFcmTokenWithRelations';
import { BusinessUnitExcludingFcmMessageIdFcmTokenWithRelations } from './businessUnitExcludingFcmMessageIdFcmTokenWithRelations';
import { DepartmentExcludingFcmMessageIdFcmTokenWithRelations } from './departmentExcludingFcmMessageIdFcmTokenWithRelations';
import { VacancyExcludingFcmMessageIdFcmTokenWithRelations } from './vacancyExcludingFcmMessageIdFcmTokenWithRelations';
import { PersonalRequisitionExcludingFcmMessageIdFcmTokenWithRelations } from './personalRequisitionExcludingFcmMessageIdFcmTokenWithRelations';
import { UserCredentialsExcludingFcmMessageIdFcmTokenWithRelations } from './userCredentialsExcludingFcmMessageIdFcmTokenWithRelations';
import { UserTenantExcludingFcmMessageIdFcmTokenWithRelations } from './userTenantExcludingFcmMessageIdFcmTokenWithRelations';
import { CompanyExcludingFcmMessageIdFcmTokenWithRelations } from './companyExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<UserWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface UserExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    firstName: string;
    hasWhatsApp?: boolean;
    lastName?: string;
    middleName?: string;
    username: string;
    email?: string;
    phone?: string;
    defaultTenant?: number;
    lastLogin?: string;
    dateBirth?: string;
    dateAdmission?: string;
    recognitionDate?: string;
    enrollment?: string | null;
    isDefaultEnrollment?: boolean;
    isSystemAccount?: boolean;
    rfc?: string;
    curp?: string;
    imss?: string;
    address?: string;
    residence?: string;
    departmentName?: string;
    photoProfileUrl?: string;
    uuid?: string;
    companyId: string;
    homeCompanyId?: string;
    jobPositionId?: string;
    departmentId?: string;
    areaId?: string;
    jobCategoryId?: string;
    processNumber?: number;
    businessUnitId?: string;
    inactiveReasonId?: string;
    cityId?: string;
    personalRequisitionId?: string | null;
    vacancyId?: string | null;
    inactivatedOn?: string;
    inactivatedBy?: number;
    otherInactiveReason?: string;
    inactiveComments?: string;
    payrollDate?: string;
    payrollInactivatedOn?: string;
    credentials?: UserCredentialsExcludingFcmMessageIdFcmTokenWithRelations;
    userTenant?: UserTenantExcludingFcmMessageIdFcmTokenWithRelations;
    company?: CompanyExcludingFcmMessageIdFcmTokenWithRelations;
    jobPosition?: JobPositionExcludingFcmMessageIdFcmTokenWithRelations;
    department?: DepartmentExcludingFcmMessageIdFcmTokenWithRelations;
    area?: AreaExcludingFcmMessageIdFcmTokenWithRelations;
    jobCategory?: JobCategoryExcludingFcmMessageIdFcmTokenWithRelations;
    businessUnit?: BusinessUnitExcludingFcmMessageIdFcmTokenWithRelations;
    inactiveReason?: InactiveReasonExcludingFcmMessageIdFcmTokenWithRelations;
    city?: CityExcludingFcmMessageIdFcmTokenWithRelations;
    personalRequisition?: PersonalRequisitionExcludingFcmMessageIdFcmTokenWithRelations;
    vacancy?: VacancyExcludingFcmMessageIdFcmTokenWithRelations;
}

